// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,

	// Local URL
	// apiEndpoint: 'https://wealthgrowth.pagekite.me/api/v1',

	// apiEndpoint: 'http://192.168.0.159:8000/api/v1',
	// apiEndpoint: 'http://localhost:8000/api/v1',
	// apiEndpoint: window.location.origin + '/api/v1',
	// apiEndpoint: 'https://wealthgrowth.1q2ohf4dskqf.us-south.codeengine.appdomain.cloud/api/v1',
  // apiEndpoint: 'https://bupi2p4ibg.us-east-1.awsapprunner.com/api/v1',

	// Live URL
	// apiEndpoint: 'http://3.223.129.159:8000/api/v1',
	// apiEndpoint: 'http://3.208.68.125:8009/api/v1',

	apiEndpoint: 'https://apiwealthgrowth.cognerium.com/api/v1',

	// apiEndpoint: 'https://allegacyapi.cognerium.com/api/v1',
	// apiEndpoint: 'https://backend.1qgr5groa53l.us-east.codeengine.appdomain.cloud/api/v1',
	// apiEndpoint: 'https://allegacy-backend.1qgr5groa53l.us-east.codeengine.appdomain.cloud/api/v1',



	chat_apiEndpoint: 'wss://wealth.cognerium.com:8004', // chat api endpoint only works for aws server not for local server
};

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
